export default {
  Name: '',
  Id: '',

};
